module.exports = __webpack_public_path__ + "img/pre_img.b2061c53.svg";